import { styled } from "@vw-marketing/us-components";

export const StyledRegistrationHeader: any = styled.div`
  ${({ theme }) => {
    return`
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static300};
      padding-bottom: ${theme.size.static300};
    `;
  }}
`;